module.exports = __webpack_public_path__ + "static/img/Drew-Brees-Most-Yards-Tds.bbff4f3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Drew-Brees-Most-Yards-Tds.gif
// module id = H7AU
// module chunks = 1